module.exports = __webpack_public_path__ + "img/Yi_Xing.41e0a710.png";